module.exports = __webpack_public_path__ + "9a31da0225a747f04be61a746a3eec0e.svg";